<template>
	<div class="pi-select">
		<div v-if="loading" class="pi-select-loading">
			<el-icon class="is-loading">
				<el-icon-loading/>
			</el-icon>
		</div>
		<el-cascader ref="cascaderRef" v-model="value" :props="cascaderProps" style="width: 100%;"
					 @change="valueChange()" v-bind="attrs"/>
	</div>
</template>

<script setup>
import {ref, watch, useAttrs, onMounted} from 'vue'
import config from "@/config/select.js";

const attrs = useAttrs()
const emit = defineEmits(['update:modelValue', 'onChange'])
const props = defineProps({
	modelValue: {},
	level: {
		type: Number,
		default: 3,
	},
	api: {type: Function, default: undefined},
	params: {type: Object, default: {}},
	props: {
		label: {
			type: String, default: "label",
		},
		value: {
			type: String, default: "value"
		},
		parent: {
			type: String, default: "parent_code"
		}
	},
})
const cascaderRef = ref(null)
let loading = ref(false)
let defaultProps = ref({
	label: config.props.label,
	value: config.props.value,
	parent: config.props.parent
})
const cascaderProps = ref({
	lazy: true,
	async lazyLoad(node, resolve) {
		const {level, value} = node
		let data = await getData(value || 0)
		data = data.map((item) => ({
			label: item[defaultProps.value.label],
			value: item[defaultProps.value.value],
			leaf: level >= props.level - 1,
		}))
		resolve(data)
	},
	multiple: false
})
let value = ref(null)

watch(() => props.modelValue, (newValue) => {
	if (!newValue) return;
	value.value = newValue
}, {immediate: true})

onMounted(() => {
	defaultProps.value = Object.assign(defaultProps.value, props.props);
})

async function getData(val) {
	const params = props.params
	params[defaultProps.value.parent] = val
	const res = await props.api(params)
	return res.data;
}

function valueChange() {
	let node = cascaderRef.value.getCheckedNodes()[0]
	emit('update:modelValue', value.value)
	emit('onChange', node)
}
</script>

<style scoped>
.pi-select {
	width: 100%;
	display: inline-block;
	position: relative;
}

.pi-select-loading {
	position: absolute;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	background: #fff;
	z-index: 100;
	border-radius: 5px;
	border: 1px solid #EBEEF5;
	display: flex;
	align-items: center;
	padding-left: 10px;
}

.pi-select-loading i {
	font-size: 14px;
}

.dark .pi-select-loading {
	background: var(--el-bg-color-overlay);
	border-color: var(--el-border-color-light);
}
</style>
